import React from 'react';
import PropTypes from 'prop-types';
import SequenceSelectAction from '../actions/SequenceSelectAction';
import QueueSequenceAction from '../actions/QueueSequenceAction';

export default class ChannelSequenceItem extends React.Component {
	static propTypes = {
		name: PropTypes.string
	};

	static contextTypes = {
		executeAction: PropTypes.func.isRequired
	};

	constructor(props) {
		super(props);
	}

	handleClickSequence() {
		this.context.executeAction(SequenceSelectAction, {
			channel: this.props.sequence.channel,
			sequence: this.props.sequence.number
		});
	}

	handleCueSequence() {
		this.context.executeAction(QueueSequenceAction, {
			channel: this.props.sequence.channel,
			sequence: this.props.sequence.number
		});
	}

	render() {
		var classes = [];

		if(this.props.sequence.number == this.props.selected) {
			classes.push('selected');
		}

		if(this.props.sequence.queued) {
			classes.push('queued');
		}

		if(this.props.sequence.playing) {
			classes.push('playing');
		}

		if(this.props.sequence.empty) {
			classes.push('empty');
		}

		return (
			<li className={classes.join(' ')}>
				<div className="icon" onClick={this.handleCueSequence.bind(this)}>
					<i className="material-icons">{ this.props.sequence.empty ? "stop" : "play_arrow" }</i>
				</div>
				<div className="name" onClick={this.handleClickSequence.bind(this)}>
					{ this.props.sequence.empty ? "" : this.props.sequence.name }
				</div>
			</li>
		);
	}
}
